// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._16hhhq60 {
  padding-top: var(--_18w76bwe);
  padding-bottom: var(--_18w76bwe);
  padding-left: var(--_18w76bwg);
  padding-right: var(--_18w76bwg);
  border-radius: var(--_18w76bw4q);
}
._16hhhq61 {
  color: #38a169;
  background-color: #c6f6d5;
}
._16hhhq62 {
  color: #3182ce;
  background-color: #bee2f8;
}
._16hhhq63 {
  color: #dd6b20;
  background-color: #feebc8;
}
._16hhhq64 {
  color: var(--_18w76bw3h);
  background-color: #fdf7f8;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;EAC/B,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,wBAAwB;EACxB,yBAAyB;AAC3B","sourcesContent":["._16hhhq60 {\n  padding-top: var(--_18w76bwe);\n  padding-bottom: var(--_18w76bwe);\n  padding-left: var(--_18w76bwg);\n  padding-right: var(--_18w76bwg);\n  border-radius: var(--_18w76bw4q);\n}\n._16hhhq61 {\n  color: #38a169;\n  background-color: #c6f6d5;\n}\n._16hhhq62 {\n  color: #3182ce;\n  background-color: #bee2f8;\n}\n._16hhhq63 {\n  color: #dd6b20;\n  background-color: #feebc8;\n}\n._16hhhq64 {\n  color: var(--_18w76bw3h);\n  background-color: #fdf7f8;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
